import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  isServiceWorkerKeepAlivePath,
  isServiceWorkerScopePath,
  registerOrderPickingServiceWorker,
  unregisterAllServiceWorkers,
} from "../../serviceWorker";

// Registers the service worker only while the user is on an order picking
// route, and unregisters it (clearing any caches) on most other routes.
// Routes a mobile user passes through on the way to order picking (see
// isServiceWorkerKeepAlivePath) are left alone so the registration doesn't
// get torn down and rebuilt on every app open. Order picking is the only
// flow that needs the forced-reload-on-update behaviour; everyone else
// should never be affected by it.
const ServiceWorkerManager = () => {
  const location = useLocation();

  useEffect(() => {
    if (isServiceWorkerScopePath(location.pathname)) {
      registerOrderPickingServiceWorker();
    } else if (!isServiceWorkerKeepAlivePath(location.pathname)) {
      unregisterAllServiceWorkers();
    }
  }, [location.pathname]);

  return null;
};

export default ServiceWorkerManager;
